document.addEventListener("DOMContentLoaded",()=>{

const main=document.getElementById("galleryMain");

const thumbs=document.querySelectorAll(".thumb");

thumbs.forEach(item=>{

item.addEventListener("click",()=>{

main.style.opacity=0;

setTimeout(()=>{

main.src=item.dataset.image;

main.style.opacity=1;

},180);

thumbs.forEach(t=>t.classList.remove("active"));

item.classList.add("active");

});

});

});

document.addEventListener("DOMContentLoaded",()=>{

const observer=new IntersectionObserver(entries=>{

entries.forEach(entry=>{

if(entry.isIntersecting){

entry.target.classList.add("visible");

}

});

},{
threshold:.15
});

document.querySelectorAll("section").forEach(section=>{

section.classList.add("fade-up");

observer.observe(section);

});

});

document.addEventListener("DOMContentLoaded",()=>{

const thumbs=document.querySelectorAll(".thumb");

const main=document.getElementById("mainImage");

if(!thumbs.length || !main) return;

thumbs.forEach(img=>{

img.addEventListener("click",()=>{

main.style.opacity="0";

setTimeout(()=>{

main.src=img.dataset.image;

main.style.opacity="1";

},180);

thumbs.forEach(t=>t.classList.remove("active"));

img.classList.add("active");

});

});

});